import { createProviderRegistry } from '../createProviderRegistry'
import { RTC_PROVIDERS } from '../../providerIds'
import { agoraRtcAdapter } from './agora'
import { dailyRtcAdapter } from './daily'
import { hundredMsRtcAdapter } from './createHundredMsRtcAdapter'

export function createRtcProviderRegistry({ providers = [] } = {}) {
  const registry = createProviderRegistry('rtc')

  ;[agoraRtcAdapter, hundredMsRtcAdapter, dailyRtcAdapter, ...providers].forEach((provider) => {
    if (provider) {
      registry.register(provider)
    }
  })

  return registry
}

export function getRtcProviderCandidateIds(sessionRoutingDecision) {
  const candidates = [
    sessionRoutingDecision?.rtcProvider,
    ...(Array.isArray(sessionRoutingDecision?.fallbackProviders)
      ? sessionRoutingDecision.fallbackProviders
      : []),
    RTC_PROVIDERS.agora,
  ].filter((providerId, index, allProviderIds) => {
    return (
      Object.values(RTC_PROVIDERS).includes(providerId) &&
      allProviderIds.indexOf(providerId) === index
    )
  })

  return candidates.length > 0 ? candidates : [RTC_PROVIDERS.agora]
}

export function preloadRtcProvidersByRoutingDecision(sessionRoutingDecision) {
  const registry = createRtcProviderRegistry()
  const candidateIds = getRtcProviderCandidateIds(sessionRoutingDecision)

  return Promise.all(
    candidateIds.map((providerId) => {
      const provider = registry.get(providerId)
      return provider?.preload ? provider.preload() : Promise.resolve()
    }),
  ).then(() => undefined)
}
